module.exports = __webpack_public_path__ + "static/media/store_best.97675bcd.svg";